import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { FixtureElement } from '../../../models/api/codegen/code';


interface IMatchItem {
    match: FixtureElement;
    route: string;
}

export const MatchItem: FC<IMatchItem> = ({match, route}) => {
    const navigate = useNavigate();

    const redirectToFixture = (fixtureId: number) => {
        navigate(`${route}event/${fixtureId}`);
    };

    return (
        <div className="hover:bg-[#272D33] border-b-2 border-transparent hover:border-red pl-[60px]">
            <li
                onClick={() => redirectToFixture(match.fi)}
                className="pt-[10px] pb-[10px] text-[#848D91] text-[14px] list-none"
            >
                {match.cn}
            </li>
        </div>
    );
};
